import { ReactNode, FunctionComponent, PropsWithChildren } from "react";
import withCursor from "../../../../hocs/withCursor.hoc"
import { CURSOR_ENUM } from "../../../Cursor";

const TextCursor: FunctionComponent<PropsWithChildren<ReactNode>> = (props: PropsWithChildren<ReactNode>) => {
  return <>{props.children}</>;
}

export default withCursor(CURSOR_ENUM.TEXT, CURSOR_ENUM.DEFAULT)(TextCursor);